import React, {useEffect, useState} from "react";
import { Box, Chip, Grid, Typography, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import {ServiceReservationComment} from "../../../components/Comment/ServiceReservationComment";
import {serviceReservationViewTable} from "../../../schema/serviceReservationViewTable";
import api from "../../../services/api";
import {ChangeDiff} from "./ChangeDiff";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: 'transparent',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderRadius: 0,
  boxShadow: '0px -1px 1px 1px #e3e3e3',
  height: '100%'
}));

type DetailPanelProps = {
  row: any;
  detail?: any;
  isLoading?: boolean;
};

export const DetailPanel: React.FC<DetailPanelProps> = ({ row }) => {

  const [isLoading, setIsLoading] = useState(false);
  const [details, setDetails] = useState<any>({});

  useEffect(() => {

    setIsLoading(false);

    api.get(`/pending-changes/${row?.id}`).then((res:any)=>{

      setDetails(res);

    }).catch(()=>{

    }).finally(()=>{
      setIsLoading(false);
    })

  }, []);

  if (isLoading) {
    return (
      <Box sx={{
        p: 2,
        background: '#f9f9f9'
      }}>
        <Typography variant="body2" color="text.secondary">Loading…</Typography>
      </Box>
    );
  }

  const item = row?.provider_side_confirmation || row?.provider_side_confirmation;
  return (
    <Box sx={{
      p: 2,
      background: '#f9f9f9'
    }}>
      <Grid container spacing={'20px'}>
        <Grid sm={12} md={4}>
          <Item>

            <Typography sx={{ mb: 0 }}>Provider Status</Typography>
            <Box>
              <Chip
                size="small"
                label={<Typography variant="caption">{item?.confirmation_status?.name ? item?.confirmation_status?.name : 'No available status'}</Typography>}
                color={
                  item?.confirmation_status?.id
                    ? (item.confirmation_status.id === 1
                      ? 'info'
                      : item.confirmation_status.id === 2
                        ? 'success'
                        : item.confirmation_status.id === 3
                          ? 'warning'
                          : 'error')
                    : 'default'
                }
              />
            </Box>

            <Typography sx={{ mb: 1,mt: 2 }}>Provider Data</Typography>
            {row?.details ? (
              <Box sx={{ mb: 1 }} dangerouslySetInnerHTML={{ __html: row.details }} />
            ) : (
              <Typography variant="body2" color="text.secondary">No changes list.</Typography>
            )}
          </Item>
        </Grid>

        <Grid sm={12} md={4}>
          <Item>

            <ChangeDiff
              type={row?.action}
              items={details?.changes} />

          </Item>
        </Grid>

        <Grid sm={12} md={4}>
          <Item>
            <ServiceReservationComment
              schema={serviceReservationViewTable}
              values={row?.changeable || row?.changeable}
              fullWidth
            />
          </Item>
        </Grid>
      </Grid>
    </Box>
  );
};
